import * as turf from '@turf/turf'
import { useFormik } from 'formik'
import * as Yup from 'yup'

import { FC } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import InputSelect from '../../../global/InputSelect/InputSelect'
import InputText from '../../../global/InputText/InputText'
import Modal from '../../../global/Modal/Modal'
import SimpleButton from '../../../global/SimpleButton/SimpleButton'
import { addEditUrls } from '../../../services/api.enums'
import { addEditDataAPI } from '../../../services/CRUDServices'
import { useEmployeeAndZoneOptions } from './useGetOption'
import { ActionSidebar } from 'redux/optime/optime'

interface HubZoneInfoFormProps {
  isOpen: boolean
  polygon: any
  setIsOpen: (isOpen: boolean) => void
  onUpdate: () => void
}
const AddZoneInfoForm: FC<HubZoneInfoFormProps> = ({
  isOpen,
  polygon,

  setIsOpen,
  onUpdate,
}) => {
  const dispatch=useDispatch()
  const { CurrentHub } = useSelector((state: any) => state.currentHubInfo)
  const { optionZone, perssonelOption } = useEmployeeAndZoneOptions({
    isOpen,
    onUpdate,
  })

  const valicationCreate = Yup.object().shape({
    code: Yup.string().required(),
    name: Yup.string().required(),
    countrytype: Yup.object().shape({
      text: Yup.string().required(),
      id: Yup.string().required(),
    }),
    employee: Yup.object().shape({
      text: Yup.string().required(),
      id: Yup.string().required(),
    }),
  })
  const formik = useFormik({
    enableReinitialize: true,
    validationSchema: valicationCreate,
    initialValues: {
      code: '',
      name: '',
      countrytype: undefined,
      employee: undefined,
    },
    onSubmit: async (values, { resetForm }) => {
      let polyData: any = {}

      let flagrequest = false
      var convertpolygon = turf.polygon([polygon.polygonCordinate])
      var center = turf.centerOfMass(convertpolygon)
      const formData = {
        id: null,
        code: values?.code,
        name: values?.name,
        countryType: values?.countrytype,
        longtitude: center?.geometry.coordinates[0],
        latitude: center?.geometry.coordinates[1],
        selectResponsiblePersonel: values?.employee,
        selectHub: CurrentHub,
      }
      try {
        const resountryDevision = await addEditDataAPI(
          addEditUrls.countryDevisioncreate,
          'post',
          formData
        )
        flagrequest = true

        polyData = {
          selectHub: CurrentHub,
          countrydevision: {
            id: resountryDevision.data.payload?.id,
            text: resountryDevision.data?.payload.name,
          },
          selectuser: {
            id: '444',
            text: '',
          },
          countrytype: values?.countrytype,
          polygon: `[[\n ${polygon.polygonCordinate.map(
            (item: any) => `\n ${JSON.stringify(item)}`
          )},\n],\n];`,
        }
        dispatch(ActionSidebar('addZone'))
        onUpdate()
        setIsOpen(false)
        // setAddSubZone(false);
        resetForm({})
        // setselectedState([]);
      } catch (error) {}

      if (flagrequest) {
        try {
          await addEditDataAPI(addEditUrls.createSubzone, 'post', polyData)
          toast.success('منطقه مورد نظر با موفقیت اضافه گردید')
          // setIsAddSubZone(false);
          setIsOpen(false)
          // setAddSubZone(false);
        } catch (error) {
        } finally {
          onUpdate()
          // setIsAddSubZone(true);
          flagrequest = false
        }
      }
    },
  })

  return (
    <Modal
      visible={isOpen}
      setVisible={() => {
        setIsOpen(false)
      }}
      title={'افزودن  اطلاعات زیر منطقه'}
    >
      <form onSubmit={formik.handleSubmit} className='p-6 '>
        <div className='grid grid-cols-2 gap-6 my-6'>
          <div className='inputRow'>
            <InputText
              wrapperClassName='w-full'
              label='کد '
              name='code'
              handleChange={formik.handleChange}
              values={formik.values.code}
              important
              type={'text'}
              error={formik.errors.code}
            />
          </div>
          <div className='inputRow'>
            <InputText
              wrapperClassName='w-full'
              label='عنوان'
              name='name'
              handleChange={formik.handleChange}
              values={formik.values.name}
              important
              type={'text'}
              error={formik.errors.name}
            />
          </div>
          <div>
            <InputSelect
              wrapperClassName='w-full '
              name='countrytype'
              label='نوع منطقه'
              values={formik.values.countrytype}
              handleChange={(name: string, value: object) => {
                formik.setFieldValue(name, value)
              }}
              options={optionZone}
            />
          </div>
          <div>
            <InputSelect
              wrapperClassName='w-full '
              name='employee'
              label='پرسنل هاب'
              values={formik.values.employee}
              handleChange={(name: string, value: object) => {
                formik.setFieldValue(name, value)
              }}
              options={perssonelOption}
            />
          </div>
        </div>
        <div className='grid grid-cols-4 gap-6 '>
          <div className='col-span-2' />
          <div className='col-span-2 flex gap-4 w-full justify-end'>
            <SimpleButton
              type='submit'
              text={' افزودن'}
              className='full-tomato-btn px-[90px] '
            />
            <SimpleButton
              type='button'
              text='لغو'
              className='full-lightTomato-btn px-[90px]'
              handelClick={() => {
                setIsOpen(false)
                // setAddSubZone(false);
                formik.resetForm()
                // setAddSubZone(true);
              }}
            />
          </div>
        </div>
      </form>
    </Modal>
  )
}

export default AddZoneInfoForm
